import type { ShortcutKeysInput } from '@/components/util/shortcuts'

import { STYLE_BLOCKS } from '../cell/toolbar/CellToolbar.editoritems'

type ShortcutAction = {
  description: string
  keys: ShortcutKeysInput
}

export type ShortcutCategory = {
  title: string
  items: ShortcutAction[]
}

export const RUNDOWN_SHORTCUTS = [
  {
    title: 'General',
    items: [
      {
        description: 'Show/hide shortcuts',
        keys: [['mod', '/']],
      },
      {
        description: 'Manage Mentions',
        keys: [['option', 'm']],
      },
      {
        description: 'Manage Text Variables',
        keys: [['option', 'v']],
      },
      {
        description: 'Close dialogs',
        keys: [['escape']],
      },
    ],
  },
  {
    title: 'Transport',
    items: [
      {
        description: 'Next cue (ends show on the last cue)',
        keys: [['Space']],
      },
      {
        description: 'Start show',
        keys: [['option', 'Space']],
      },
      {
        description: 'Open Trash',
        keys: [['mod', 'z']],
      },
    ],
  },

  {
    title: 'Cells',
    items: [
      {
        description: 'Move between cells',
        keys: [['↑'], ['↓'], ['←'], ['→']],
      },

      {
        description: 'Edit current cell',
        keys: [['enter'], ['Double-click']],
      },
      {
        description: 'Save cell changes',
        keys: [['mod', 'enter']],
      },
      {
        description: 'Discard cell changes',
        keys: [['escape']],
      },
      {
        description: 'Deselect current cell',
        keys: [['escape']],
      },
      {
        description: 'Move between cell and toolbar',
        keys: [['Tab']],
      },
      {
        description: 'Move between toolbar items',
        keys: [['↑'], ['↓'], ['←'], ['→']],
      },
    ],
  },
  {
    title: 'Output (Prompter)',
    items: [
      {
        description: 'Start/stop scrolling',
        keys: [['Space']],
      },
      {
        description: 'Increase scrolling speed',
        keys: [['→']],
      },
      {
        description: 'Decrease scrolling speed',
        keys: [['←']],
      },
      {
        description: 'Jump to top',
        keys: [['↑']],
      },
      {
        description: 'Jump to active cue',
        keys: [['↓']],
      },
    ],
  },
  {
    title: 'Cell formatting',
    items: [
      ...STYLE_BLOCKS.map((item) => {
        return {
          description: item.label,
          keys: item.shortcut,
        }
      }),
      {
        description: 'Bold',
        keys: [['mod', 'b']],
      },
      {
        description: 'Italic',
        keys: [['mod', 'i']],
      },
      {
        description: 'Strikethrough',
        keys: [['mod', 'shift', 's']],
      },
      {
        description: 'Clear formatting',
        keys: [['mod', '\\']],
      },
      {
        description: 'Insert separator',
        keys: [['mod', 'shift', '-']],
      },
      {
        description: 'Toggle text case',
        keys: [['mod', 'shift', 'u']],
      },
    ],
  },
] as const satisfies ShortcutCategory[]
